import { TERMO_BLOCOS } from "@/lib/termoConteudo";

// Lote 87 — texto do Termo de Uso e Aviso de Privacidade (fonte: lib/termoConteudo.js).
// Usado na tela de aceite (/aceite, com rolagem obrigatória) e na página pública /termo.
function Runs({ runs }) {
  return (
    <>
      {runs.map((r, i) => {
        let el = r.t;
        if (r.b) el = <strong key={`b${i}`} className="font-semibold text-stone-900">{el}</strong>;
        if (r.i) el = <em key={`i${i}`}>{el}</em>;
        return <span key={i}>{el}</span>;
      })}
    </>
  );
}

export default function TermoTexto() {
  return (
    <div className="text-[13.5px] leading-relaxed text-stone-700 text-left sm:text-justify hyphens-auto space-y-3" data-testid="termo-texto">
      {TERMO_BLOCOS.map((b, i) => {
        if (b.k === "h") {
          return (
            <h3 key={i} className="font-display text-base font-bold text-stone-900 pt-3 first:pt-0 text-left">
              {b.text}
            </h3>
          );
        }
        if (b.k === "p") return <p key={i}><Runs runs={b.r} /></p>;
        if (b.k === "ul" || b.k === "ol") {
          const L = b.k === "ul" ? "ul" : "ol";
          return (
            <L key={i} className={`${b.k === "ul" ? "list-disc" : "list-decimal"} pl-5 space-y-1.5`}>
              {b.items.map((it, j) => <li key={j}><Runs runs={it} /></li>)}
            </L>
          );
        }
        if (b.k === "table") {
          return (
            <div key={i} className="overflow-x-auto text-left">
              <table className="w-full text-xs border border-stone-200 border-collapse">
                <thead>
                  <tr className="bg-stone-100">
                    {b.rows[0].map((c, j) => (
                      <th key={j} className="border border-stone-200 px-2 py-1.5 text-left font-semibold text-stone-800"><Runs runs={c} /></th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {b.rows.slice(1).map((row, r) => (
                    <tr key={r}>
                      {row.map((c, j) => (
                        <td key={j} className="border border-stone-200 px-2 py-1.5 align-top"><Runs runs={c} /></td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}
